import { useState } from 'react';
import './to-do-list.styles.scss';
import TaskList from './components/task-list/task-list.component';
import Input from './components/input/input.component';
import Date from './components/date/date.component';
import Button from '../../components/button/button.component';
let taskId = 2;
const defaultList = [{ id: 1, title: null, isDone: false }];

const ToDoList = () => {
  const [tasks, setTasks] = useState(defaultList);
  const [title, setTitle] = useState('');

  const handleChange = (event) => {
    event.preventDefault();
    setTitle(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setTitle('');
    if (title) {
      setTasks([
        ...tasks,
        {
          id: taskId++,
          title: title,
          isDone: false,
        },
      ]);
    }
  };

  const handleDelete = (toDeleteID) => {
    console.log('Called');
    setTasks(tasks.filter((task) => task.id !== toDeleteID));
  };

  return (
    <div className='to-do-list'>
      <Button btnText='Return Back' />
      <Date />
      <div className='list-container'>
        <Input
          title={title}
          handleSubmit={handleSubmit}
          handleChange={handleChange}
        />
        <TaskList tasks={tasks} handleDelete={handleDelete} />
      </div>
    </div>
  );
};

export default ToDoList;
